// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3MxrQ","addWidgetButton":"Header_addWidgetButton__1_GP7","dashboardTabs":"Header_dashboardTabs__3yfID","active":"Header_active__2F-0K"};